import { Link, useNavigate } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { Minus, Plus, Trash, ShoppingBag } from "@phosphor-icons/react";

export default function Cart() {
  const { items, updateQty, removeItem, total } = useCart();
  const navigate = useNavigate();

  const goCheckout = () => navigate("/checkout");

  if (items.length === 0) {
    return (
      <div className="max-w-2xl mx-auto px-6 py-32 text-center" data-testid="cart-empty">
        <ShoppingBag size={48} className="mx-auto text-stone-300" />
        <h1 className="font-serif text-3xl text-stone-900 mt-6">Tu carrito está vacío</h1>
        <p className="text-stone-500 mt-3">Descubre nuestras fragancias y piezas de decoración.</p>
        <Link to="/shop" className="inline-block mt-8 bg-[#3F4E4F] text-white px-8 py-4 hover:bg-[#2C3637] transition-colors" data-testid="cart-shop-link">Ir a la tienda</Link>
      </div>
    );
  }

  return (
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-12" data-testid="cart-page">
      <h1 className="font-serif text-4xl md:text-5xl text-stone-900 mb-10">Tu carrito</h1>
      <div className="grid lg:grid-cols-3 gap-12">
        <div className="lg:col-span-2 divide-y divide-stone-200">
          {items.map((item) => (
            <div key={item.id} className="flex gap-5 py-6" data-testid={`cart-item-${item.id}`}>
              <img src={item.image} alt={item.name} className="w-24 h-28 object-cover bg-[#F0EFEB]" />
              <div className="flex-1">
                <h3 className="font-serif text-lg text-stone-900">{item.name}</h3>
                <div className="text-stone-500 text-sm mt-1">
                  ${item.unit_price.toFixed(2)} c/u
                  {item.unit_price < item.price && <span className="ml-2 text-stone-400 line-through text-xs">${item.price.toFixed(2)}</span>}
                  {item.unit_price < item.price && <span className="ml-1 text-[#166534] text-xs">precio por cantidad</span>}
                </div>
                <div className="flex items-center gap-4 mt-4">
                  <div className="flex items-center border border-stone-300">
                    <button onClick={() => updateQty(item.id, item.quantity - 1)} className="px-3 py-2 hover:bg-stone-100" data-testid={`cart-dec-${item.id}`}><Minus size={14} /></button>
                    <span className="px-4 text-sm">{item.quantity}</span>
                    <button onClick={() => updateQty(item.id, item.quantity + 1)} className="px-3 py-2 hover:bg-stone-100" data-testid={`cart-inc-${item.id}`}><Plus size={14} /></button>
                  </div>
                  <button onClick={() => removeItem(item.id)} className="text-stone-400 hover:text-[#991B1B]" data-testid={`cart-remove-${item.id}`}><Trash size={18} /></button>
                </div>
              </div>
              <div className="font-medium text-stone-900">${(item.unit_price * item.quantity).toFixed(2)}</div>
            </div>
          ))}
        </div>

        <div className="lg:col-span-1">
          <div className="bg-white border border-stone-200 p-8 sticky top-28" data-testid="cart-summary">
            <h2 className="font-serif text-2xl text-stone-900 mb-6">Resumen</h2>
            <div className="flex justify-between text-stone-600 mb-3"><span>Subtotal</span><span data-testid="cart-subtotal">${total.toFixed(2)}</span></div>
            <div className="flex justify-between text-stone-600 mb-3"><span>Envío</span><span>Se calcula al pagar</span></div>
            <div className="border-t border-stone-200 my-4" />
            <div className="flex justify-between text-stone-900 text-lg font-medium mb-6"><span>Total</span><span data-testid="cart-total">${total.toFixed(2)}</span></div>
            <button onClick={goCheckout} className="w-full bg-[#3F4E4F] text-white py-4 hover:bg-[#2C3637] transition-colors" data-testid="checkout-button">Proceder al pago</button>
            <Link to="/shop" className="block text-center text-sm text-stone-500 hover:text-stone-900 mt-4">Seguir comprando</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
